import { create } from "zustand";
import type { CollectionCard } from "modules/collections/details/model/collection";
import { collectionCardTransitionKey } from "modules/collections/details/utils/collectionCardTransitionKey";

export function collectionCardPendingAddKey(card: CollectionCard): string {
  return collectionCardTransitionKey({ ...card, tradeItem: undefined });
}

interface CollectionCardPendingState {
  pendingAddKeys: Set<string>;
  beginAdd: (key: string) => void;
  endAdd: (key: string) => void;
}

/** Keeps an in-flight create locked even if a background row refetches. */
export const useCollectionCardPendingStore = create<CollectionCardPendingState>(
  (set) => ({
    pendingAddKeys: new Set(),
    beginAdd: (key) =>
      set((state) => {
        if (state.pendingAddKeys.has(key)) return state;
        const pendingAddKeys = new Set(state.pendingAddKeys);
        pendingAddKeys.add(key);
        return { pendingAddKeys };
      }),
    endAdd: (key) =>
      set((state) => {
        if (!state.pendingAddKeys.has(key)) return state;
        const pendingAddKeys = new Set(state.pendingAddKeys);
        pendingAddKeys.delete(key);
        return { pendingAddKeys };
      }),
  })
);
